import { z } from 'zod';

/** Output of `appointmentToCalendarEvent` — keep in sync with `features/calendar/types`. */
export const providerCalendarEventSchema = z.object({
  id: z.string(),
  title: z.string(),
  description: z.string().optional(),
  start: z.date(),
  end: z.date(),
  type: z.enum(['appointment', 'meeting', 'task', 'blocked']),
  color: z.string(),
  client: z.string().optional(),
  provider: z.string().optional(),
  status: z
    .enum([
      'proposed',
      'scheduled',
      'attended',
      'client-cancelled',
      'client-late-cancelled',
      'clinician-cancelled',
      'client-no-show',
      'entered-in-error',
    ])
    .optional(),
  modality: z.enum(['in-person', 'telehealth', 'hybrid']).optional(),
  sessionTypeId: z.string().optional(),
  sessionTypeDisplay: z.string().optional(),
  serviceTypeCode: z.string().optional(),
  additionalParticipants: z.array(z.object({
    resourceType: z.string(),
    id: z.string(),
    display: z.string().optional(),
  })).optional(),
  patientId: z.string().optional(),
  practitionerId: z.string().optional(),
  ownerPractitionerId: z.string().optional(),
  originalDisplayColor: z.string().optional(),
  canManage: z.boolean().optional(),
  isPrivacyRestricted: z.boolean().optional(),
  episodeOfCareId: z.string().optional(),
  episodeOfCareTypeCode: z.string().optional(),
  locationLabel: z.string().optional(),
  siteId: z.string().optional(),
  roomId: z.string().optional(),
  deviceIds: z.array(z.string()).optional(),
  appointmentCategory: z.enum(['session', 'group', 'meeting', 'time-entry']).optional(),
  therapyGroupId: z.string().optional(),
  therapyGroupDisplay: z.string().optional(),
  clients: z.array(z.string()).optional(),
  isInvitedEvent: z.boolean().optional(),
  linkedNoteSigned: z.boolean().optional(),
  videoLink: z.string().url().optional(),
});

export type ProviderCalendarEventParsed = z.infer<typeof providerCalendarEventSchema>;
